type StructuredClone = <T>(value: T) => T

/**
 * The browser's `structuredClone` - the copy a `BroadcastChannel` makes.
 * Reached through `globalThis` because the TypeScript that compiles the tests
 * (4.5) predates its declaration.
 */
export const cloneStructured: StructuredClone = value =>
	(
		globalThis as typeof globalThis & { structuredClone: StructuredClone }
	).structuredClone(value)
